// extracted by mini-css-extract-plugin
module.exports = {"DocLinks":"OT-1RAzdBkkqCgYwwxCCTw=="};